import React from "react";
import { useTranslation } from "react-i18next";
import { RaffleInfoButton } from "./RaffleInfoButton";
import { WheelPin } from "./WheelPin";
import { WheelRims } from "./WheelRims";
import { WheelSectors } from "./WheelSectors";
import { useRaffleWheel } from "./RaffleWheelContext";
import { WHEEL_SIZE } from "./wheelMath";
import cls from "./styles.module.scss";

export const WheelSurface = () => {
  const { t } = useTranslation();
  const {
    normalWheelSize,
    scale,
    wheelSize,
  } = useRaffleWheel();
  const svgSize = WHEEL_SIZE * scale;

  return (
    <div className={cls.root}>
      <div
        className={cls.wheelWrap}
        style={{
          width: `${normalWheelSize}px`,
          height: `${normalWheelSize}px`,
        }}
      >
        <RaffleInfoButton />
        <div
          className={cls.wheel}
          style={
            {
              width: `${wheelSize}px`,
            } as React.CSSProperties
          }
          aria-label={t("raffle.a11y.participantsWheel")}
        >
          <svg
            className={cls.svg}
            width={wheelSize}
            height={wheelSize}
            viewBox={`0 0 ${svgSize} ${svgSize}`}
            role="img"
          >
            <defs>
              <filter id="sectorInnerShadow">
                <feOffset dx="0" dy="8" />
                <feGaussianBlur stdDeviation="10" result="offsetBlur" />
                <feComposite
                  in="offsetBlur"
                  in2="SourceAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                  result="innerShadow"
                />
                <feColorMatrix
                  in="innerShadow"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"
                />
                <feComposite in2="SourceGraphic" operator="over" />
              </filter>
            </defs>
            <WheelRims />
            <WheelSectors />
          </svg>
          <WheelPin />
        </div>
      </div>
    </div>
  );
};
